import { Dialog } from "../../../core/view";
import * as marietta from '../../../';

export class AutoBeamCheckDialog extends Dialog {

    constructor(draggable: boolean) {
        super(draggable);

        const id = 'AutoBeamCheckDialog';
        const title = (marietta.webcad.WebCADGlobal.language === 'jp') ? '梁の自動生成' : 'Genarate Beams';

        let contents = '<div class=""><p>入力済みの梁を削除し、自動生成しますか？</p><div>';
        
        let footer: string = '<button id="btnDoneBeamSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
        footer += '<button id="btnClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';


        this.createDialog(id, title, contents, footer);

        document.getElementById('btnDoneBeamSetting').addEventListener('click', this.autoGenerateBeam);
        document.getElementById('btnClose').addEventListener('click', this.close);
    }

    /**
     * 梁の自動生成
     */
    private autoGenerateBeam = (e) => {
        e.preventDefault();

        // 梁を削除する
        const currentFloor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
        const floorLayer = <marietta.webcad.layer.FloorLayer>marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(currentFloor);
        const tarLayer = <marietta.webcad.layer.ItemLayer>floorLayer.layer_beam;
        tarLayer.removeAllChildren();

        marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
        // 梁を自動生成する
        const autoBeam = new marietta.webcad.AutoGenerator.AutoBeam();
        autoBeam.createBeamOuterWall();
        
        // 梁が存在していたらウィザード開始
        if (marietta.webcad.WebCADGlobal.itemManager.hasBeam()) {
            marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.WizardBeamSizeSettingDialog);
        }

        this.close();
    }

}